import React from 'react';

import { getClassNames } from '@RHEnvironmental/pattern-library/dist/js/services/stylingUtils';
import Header from '../Header/Header';
import AlertBox from '../AlertBox';
import { RenderIf } from '../RenderIf/RenderIf';
import {config} from "../../../services/config";
import {isLoggedIn} from "../../../services/auth";

const MainLayout = ({
    children,
    className = undefined,
    centerContent = false,
    hideHeader = false,
    viewOnly = false,
    centerContentAdditionalClasses = '',
    showAlerts = true
}) => {
    const classNames = getClassNames(className, {
        'main-layout': true,
    });

    const logoLink = isLoggedIn() && !viewOnly ? '/inspections' : config('marketing_url');

    return (
        <div className={classNames}>
            {!hideHeader && <Header isViewOnly={viewOnly} logoLink={logoLink} />}
            <section
                id="main-content"
                className={`main-layout__content ${
                    centerContent && 'flex column center text-center'
                } ${centerContentAdditionalClasses}`}
            >
                {showAlerts && <AlertBox />}
                {children}
            </section>
        </div>
    );
};

export default MainLayout;
